const e = {
  "teaser-wall": "teaser-wall",
  "teaser-wall__teasers": "teaser-wall__teasers",
  "teaser-wall__teaser": "teaser-wall__teaser",
  "teaser-wall__button": "teaser-wall__button"
};
export {
  e as default
};
